import * as React from 'react';
import styled from 'styled-components';
import { Styledes, Childable, Closeable } from './types';
import { Layout } from './slots';

export interface Props extends Styledes, Childable, Closeable {}

const Header = styled.div`
    border-bottom: 1px solid #e9e9ea;
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-flow: column;
    align-items: center;
    min-height: 60px;

    & > * {

        &:first-of-type {
            padding-left: 30px;
        }

        &:last-of-type {
            padding-right: 30px;
        }
    }
`;

export default React.memo(({ children, className, handleClose }: Props) => {
    return (
        <Header className={className}>
            <Layout name="title" />
            {children}
            <Layout name="close" handleClose={handleClose} />
        </Header>
    );
});
